import React, { useEffect, useState } from "react";
import classes from "./styles/style.module.css";
import appApi from "../../../assets/utils/AppApi";
import {
  convertToShamsi,
  convertToShamsiTime,
} from "../../../assets/utils/ConvertToShamsi";
import Loading from "../../../assets/containers/loadingDialog";
import { useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const ScoresList = () => {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const order = searchParams.get("order");

  useEffect(() => {
    if (id) {
      if (order === "monthly") {
        getMonthlyScoreById();
      } else {
        getScoreById();
      }
    } else {
      getScores();
    }
  }, [id, order]);

  const getMonthlyScoreById = () => {
    setLoading(true);
    appApi
      .get(`/score/user/history/others/monthly/${id}`)
      .then(({ data }) => {
        setUserName(data.user.fullName);
        setScores(data.userScores);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getScoreById = () => {
    setLoading(true);
    appApi
      .get(`/score/user/history/others/${id}`)
      .then(({ data }) => {
        setUserName(data.user.fullName);
        setScores(data.userScores);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getScores = () => {
    setLoading(true);
    appApi
      .get("/score/user/history")
      .then(({ data }) => {
        setScores(data.userScores);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const ScoreElement = ({ score }) => {
    return (
      <div className={classes.scoreElement}>
        <div className={classes.dateContainer}>
          <p>{convertToShamsiTime(score.createdAt)}</p>
          <p>{convertToShamsi(score.createdAt)}</p>
        </div>
        <div className={classes.socreText}>
          <p className={classes.desc}>{score.reason}</p>
          <p className={classes.score}>{score.score}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="w-100">
      {loading ? (
        <Loading
          size={30}
          className={"w-100 d-flex justify-content-center py-5 my-5"}
        />
      ) : scores.length === 0 ? (
        <p className="text-center">موردی برای نمایش وجود ندارد</p>
      ) : (
        <>
          {userName && <p className="text-center">{userName}</p>}
          {scores.map((score) => {
            return <ScoreElement score={score} key={score._id} />;
          })}
        </>
      )}
    </div>
  );
};

export default ScoresList;
